import { mapGetters } from "vuex";

export const authComputed = {
    ...mapGetters(["loggedIn"]),
};

export const getUser = {
    ...mapGetters(["currentUser"]),
};

export const getuserDetails = {
    ...mapGetters(["userDetails"]),
};

export const getaccessCode = {
    ...mapGetters(["currentAccess"]),
};